<div class="dialog-content-wrapper-contact">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Edición Chatbot</span>
      <button
        mat-icon-button
        (click)="matDialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="chat-visual-editor">
    <div class="editor-container">
      <!-- PANEL DE CONFIGURACIÓN -->
      <div class="style-panel">
        <label>Color de fondo</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.backgroundColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.backgroundColor"
            placeholder="#ffffff"
            class="color-code-input" />
        </div>

        <label>Color del encabezado</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.headerBackgroundColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.headerBackgroundColor"
            placeholder="#2D323E"
            class="color-code-input" />
        </div>
        <label>Título del encabezado</label>
        <input
          type="text"
          [(ngModel)]="visual.headerText"
          placeholder="Asistente Virtual"
          class="chat-title-input" />

        <label>Imagen del encabezado</label>
        <div class="custom-file-input-wrapper">
          <p class="file-helper-text">
            Selecciona una imagen con un tamaño máximo de 100 KB
          </p>
          <button
            mat-raised-button
            class="small-btn"
            color="accent"
            (click)="avatarFileInput.click()">
            Seleccionar
          </button>
          <input
            #avatarFileInput
            type="file"
            accept="image/png, image/jpeg, image/webp"
            style="display: none"
            (change)="onAvatarImageSelected($event)" />
          <p class="error-text" *ngIf="imageErrors.avatar">
            {{ imageErrors.avatar }}
          </p>
        </div>

        <label>Color del mensaje del bot</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.botBubbleColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.botBubbleColor"
            placeholder="#cccccc"
            class="color-code-input" />
        </div>

        <label>Texto del mensaje del bot</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.botTextColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.botTextColor"
            placeholder="#000000"
            class="color-code-input" />
        </div>

        <label>Color del mensaje del usuario</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.userBubbleColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.userBubbleColor"
            placeholder="#4caf50"
            class="color-code-input" />
        </div>

        <label>Texto del mensaje del usuario</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.userTextColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.userTextColor"
            placeholder="#ffffff"
            class="color-code-input" />
        </div>

        <label>Color del área de escritura</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.inputBackgroundColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.inputBackgroundColor"
            placeholder="#f0f0f0"
            class="color-code-input" />
        </div>

        <label>Color del botón de envío</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.sendButtonColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.sendButtonColor"
            placeholder="#1976d2"
            class="color-code-input" />
        </div>

        <label>Color del botón flotante</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [(ngModel)]="visual.laucherColor"
            style="cursor: pointer" />
          <input
            type="text"
            [(ngModel)]="visual.laucherColor"
            placeholder="#1976d2"
            class="color-code-input" />
        </div>

        <label>Imagen del botón flotante</label>
        <div class="custom-file-input-wrapper">
          <p class="file-helper-text">
            Selecciona una imagen con un tamaño máximo de 100 KB
          </p>
          <button
            mat-raised-button
            class="small-btn"
            color="accent"
            (click)="launcherFileInput.click()">
            Seleccionar
          </button>
          <input
            #launcherFileInput
            type="file"
            class="small-btn"
            accept="image/png, image/jpeg, image/webp"
            style="display: none"
            (change)="onLauncherImageSelected($event)" />
          <p class="error-text" *ngIf="imageErrors.launcher">
            {{ imageErrors.launcher }}
          </p>
        </div>
      </div>

      <!-- VISTA PREVIA -->
      <div class="preview-panel">
        <div
          class="chat-preview"
          [ngStyle]="{
            'background-color': visual.backgroundColor,
            'font-family': visual.fontFamily,
            'font-size': visual.fontSize,
            'border-radius': visual.chatBorderRadius,
            'box-shadow': visual.boxShadow
          }">
          <div
            class="chat-header"
            [ngStyle]="{
              'background-color': visual.headerBackgroundColor,
              color: visual.headerTextColor,
              'font-size': visual.headerFontSize,
              'font-weight': visual.headerFontWeight
            }">
            <div class="avatar-wrapper">
              <img
                class="avatar"
                src="../../../assets/icons/svg/icon-chatbot.svg"
                loading="lazy"
                alt="Attached from chat message"
                *ngIf="visual.headerBotUrl == null" />
              <img
                class="avatar"
                [src]="visual.headerBotUrl"
                loading="lazy"
                alt="Bot avatar"
                *ngIf="visual.headerBotUrl !== null" />
            </div>
            <span class="chat-title">{{ visual.headerText }}</span>
          </div>

          <div class="chat-body">
            <div
              class="bot-message"
              [ngStyle]="{
                'background-color': visual.botBubbleColor,
                color: visual.botTextColor,
                'border-radius': visual.bubbleBorderRadius,
                padding: visual.bubblePadding
              }">
              <span>¡Hola! ¿En qué puedo ayudarte?</span>
            </div>

            <div
              class="user-message"
              [ngStyle]="{
                'background-color': visual.userBubbleColor,
                color: visual.userTextColor,
                'border-radius': visual.bubbleBorderRadius,
                padding: visual.bubblePadding
              }">
              <span>Quiero saber sobre mis pedidos.</span>
            </div>
          </div>

          <div
            class="chat-input"
            [ngStyle]="{
              'background-color': visual.inputBackgroundColor,
              color: visual.inputTextColor
            }">
            <input
              type="text"
              placeholder="Escribe un mensaje..."
              [ngStyle]="{
                'background-color': visual.inputBackgroundColor,
                color: visual.inputTextColor
              }" />
            <button
              class="send-button"
              [ngStyle]="{
                'background-color': visual.sendButtonColor,
                color: visual.sendIconColor
              }"
              style="cursor: unset">
              <mat-icon class="custom-icon" style="padding: 2px 2px">send</mat-icon>
            </button>
          </div>
        </div>
        <div
          class="chat-launcher"
          title="Abrir/cerrar chat"
          [ngStyle]="{
            'background-color': visual.laucherColor,
            'background-image': visual.botAvatarUrl
              ? 'url(' + visual.botAvatarUrl + ')'
              : '',
            'background-size': visual.botAvatarUrl ? 'cover' : '',
            'background-position': visual.botAvatarUrl ? 'center' : ''
          }"></div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="mt-10 mat-dialog-actions">
    <button
      mat-raised-button
      type="button"
      class="mr-8"
      aria-label="cancel"
      (click)="matDialogRef.close()">
      {{ 'CANCEL' | translate }}
    </button>

    <button
      mat-raised-button
      type="button"
      class="submit-button"
      color="accent"
      class="save-button"
      aria-label="SAVE"
      (click)="
        matDialogRef.close([
          'save',
          visual,
          selectedLauncherFile,
          selectedAvatarFile
        ])
      ">
      <span style="display: flex; justify-content: center"> </span>
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
